(ns entities.specs
  (:require
    [entities.assets.specs :as assets]
    [entities.estate.specs :as estate]
    [entities.expenses.specs :as expenses]
    [entities.income.specs :as income]
    [entities.insurance.specs :as insurance]
    [entities.key-accomplishments.specs :as key-accomplishments]
    [entities.liabilities.specs :as liabilities]
    [entities.partner.specs :as partner]
    [entities.priorities.specs :as priorities]
    [entities.review.specs :as review]
    [entities.risk-profile.specs :as risk-profile]
    [entities.tax.specs :as tax]
    [very.re-frame.specs :as sp]
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::type keyword?)
(s/def ::op #{:get :patch :post :delete})
(s/def ::data map?)

(s/def ::success ::sp/event-vec)
(s/def ::error ::sp/event-vec)
(s/def ::regardless ::sp/event-vec)

(s/def ::get (s/keys :req-un [::type
                              ::op]
                     :opt-un [::success
                              ::error
                              ::regardless]))

(s/def ::patch (s/keys :req-un [::type
                                ::op
                                ::data]
                       :opt-un [::success
                                ::error
                                ::regardless]))

(s/def ::fx (s/or :get ::get
                  :patch ::patch))

(s/def ::spec (s/or :single ::fx
                    :multiple (s/coll-of ::fx
                                         :kind vector?
                                         :min-count 1)))

(s/def ::entities (s/keys :opt-un [
                                   ::assets/assets
                                   ::estate/estate
                                   ::expenses/expenses
                                   ::income/income
                                   ::insurance/insurance
                                   ::liabilities/liabilities
                                   ::key-accomplishments/key-accomplishments
                                   ::partner/partner
                                   ::priorities/priorities
                                   ::review/review
                                   ::risk-profile/risk-profile
                                   ::tax/tax
                                   ]))

